var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayArrow = function SvgPlayArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play_arrow_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play_arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.175V6.825q0-.424.3-.713a.98.98 0 0 1 .962-.25q.138.038.263.113l8.15 5.175q.225.15.337.375a1.05 1.05 0 0 1 0 .95.97.97 0 0 1-.337.375l-8.15 5.175a1.04 1.04 0 0 1-.525.15.98.98 0 0 1-.7-.288.95.95 0 0 1-.3-.712m2-1.825L15.25 12 10 8.65z"
  }))));
};
export default SvgPlayArrow;